// auto-generated by Typewriter template _enums.tst from PortCall.Models\DomainSettings\VesselServiceSettings.cs
export enum VesselServiceActive { 
    InActive = 0,
    Active = 10
}

export const VesselServiceActiveDisplayName : { [val : number] : string } = { 
    0: 'InActive',
    10: 'Active'
}

export const VesselServiceActives : { Id : VesselServiceActive, Name : string }[] = [ 
    { Id: VesselServiceActive.InActive, Name: 'InActive' },
    { Id: VesselServiceActive.Active, Name: 'Active' }
]



// WEBPACK FOOTER //
// ./server/enums/VesselServiceActive.ts